// A Traiter API

import { apiClient } from '@/core/api/client';
import type { 
  ATraiterApiResponse, 
  ATraiterStatsResponse 
} from '../types/a-traiter.types';

export const aTraiterAPI = {
  /**
   * Get list of expertises to process (a traiter)
   */
  async getATraiter(): Promise<ATraiterApiResponse> {
    try {
      const response = await apiClient.get<ATraiterApiResponse>('/api/expert/a-traiter');
      return response;
    } catch (error) {
      console.error('Error fetching a-traiter expertises:', error);
      throw error;
    }
  },

  /**
   * Get statistics for a-traiter dashboard
   */
  async getStats(): Promise<ATraiterStatsResponse> {
    try {
      const response = await apiClient.get<ATraiterStatsResponse>('/api/expert/stats');
      return response;
    } catch (error) {
      console.error('Error fetching expert stats:', error);
      throw error;
    }
  },

  /**
   * Mark an expertise as urgent
   */
  async markAsUrgent(expertiseId: number): Promise<{ success: boolean }> {
    try {
      const response = await apiClient.post<{ success: boolean }>(`/api/expert/expertise/${expertiseId}/urgent`);
      return response;
    } catch (error) {
      console.error('Error marking expertise as urgent:', error);
      throw error;
    }
  },

  /**
   * Update expertise status
   */
  async updateStatus(
    expertiseId: number,
    status: string
  ): Promise<{ success: boolean }> {
    try {
      const response = await apiClient.put<{ success: boolean }>(`/api/expert/expertise/${expertiseId}/status`, {
        status
      });
      return response;
    } catch (error) {
      console.error('Error updating expertise status:', error);
      throw error;
    }
  }
};